<template>
  <Dialog :title="$t('Sesiones del bono')" v-model="show">
    <!-- Contenido del Dialog, Formulario -->
    <template v-if="bono_vendido" v-slot:content>
      <v-row>
        <v-col cols="12">
          <!-- Tabla de sesiones -->
          <v-data-table
              :headers="tabla_sesiones.headers"
              :items="bono_vendido.sesiones"
              :server-items-length="bono_vendido.sesiones.length"
              :fixed-header="true"
              class="elevation-3"
              calculate-widths
              hide-default-footer
              :no-data-text="$t('No hay datos')"
              :no-results-text="$t('No hay datos')"
              :item-class="get_item_class"
          >
            <template v-slot:item.fecha="{ item }">
              {{ item.fecha | moment('DD/MM/YYYY HH:mm') }}
            </template>

            <template v-slot:item.actions="{ item }" v-if="(!item.centro_id || item.centro_id === $store.state.centro.centro.id) &&
             ($store.state.auth.user.is_superuser || $store.state.auth.user.tipo_empleado === 'admin')">
              <v-btn @click="rectificar_sesion(item)"
                     class="ml-1"
                     color="red"
                     icon
                     :title="$t('Generar venta rectificativa')"
                     v-if="item.cantidad > 0 && !item.is_rectificada && !$store.state.centro.centro.is_ticketbai_activo"
              >
                <v-icon
                    color="red"
                >
                  mdi-arrow-u-left-top
                </v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-col>
      </v-row>


      <v-row class="mt-3" v-if="bono_vendido.servicios.length > 0">
        <v-col cols="12">
          <!-- Tabla de servicios -->
          <v-data-table
              :headers="tabla_servicios.headers"
              :items="bono_vendido.servicios"
              :server-items-length="bono_vendido.servicios.length"
              :fixed-header="true"
              class="elevation-3"
              calculate-widths
              hide-default-footer
          />
        </v-col>
      </v-row>

      <v-row class="mt-3" v-if="bono_vendido.productos.length > 0">
        <v-col cols="12">
          <!-- Tabla de productos -->
          <v-data-table
              :headers="tabla_productos.headers"
              :items="bono_vendido.productos"
              :server-items-length="bono_vendido.productos.length"
              :fixed-header="true"
              class="elevation-3"
              calculate-widths
              hide-default-footer
          />
        </v-col>
      </v-row>
    </template>
    <!-- Acciones de la derecha del dialog -->
    <template v-slot:right-action>
      <v-btn @click="imprimir_sesiones_bono" small class="primary">
        <v-icon small>mdi-print</v-icon>
        {{  $t("Imprimir") }}
      </v-btn>
    </template>
  </Dialog>
</template>


<script>
import CONSTANTS from "@/utils/constants";
export default {
  name: 'DialogSesiones',
  props: ['value', 'item'],

  data: () => ({
    CONSTANTS,
    bono_vendido: null,
    tabla_sesiones: {
      headers: []
    },
    tabla_servicios: {
      headers: []
    },
    tabla_productos: {
      headers: []
    },
  }),

  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },

  methods: {
    async get_bono_vendido(bono_vendido_id){
      this.bono_vendido = await this.$store.dispatch('bono/get_sesiones_bono_vendido', bono_vendido_id)
    },
    get_item_class(item) {
      return item.cantidad > 0 ? '' : 'red--text'
    },

    /**
     * Elimina una sesión
     */
    async rectificar_sesion(sesion) {
      if (this.item.centro_id && this.item.centro_id !== this.$store.state.centro.centro.id) return
      try{
        try {
          await this.$store.dispatch('bono/rectificar_sesion_bono', sesion)
          this.$snotify.success(
            this.$t("La acción se ha realizado correctamente"),
            this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
          )
          await this.get_bono_vendido(this.bono_vendido.id)
          this.$emit('on_delete_sesion')
        } catch (err) {
          this.$snotify.error(
            this.$t("Ha ocurrido un error"),
            this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
          )
        }
      } catch (err) {}
    },

    imprimir_sesiones_bono() {
      const routeData = this.$router.resolve({ name: 'print_sesiones_bonos', params: { id: this.bono_vendido.id } })
      window.open(routeData.href, '_blank');
    },
  },

  mounted() {
    this.get_bono_vendido(this.item.id)

    this.tabla_sesiones.headers = [
      { text: this.$t("Fecha"), value: "fecha", class: "primary white--text", sortable: false},
      { text: this.$t("Cantidad"), value: "cantidad", class: "primary white--text", sortable: false, align:'center' },
      { text: `${this.$t("Servicio")} / ${this.$t("Producto")}`, value: "descripcion", class: "primary white--text", sortable: false },
      { text: '', value: 'actions', class: "primary white--text", sortable: false, align: 'right', width: "80px" },
    ]

    this.tabla_servicios.headers = [
      { text: this.$t("Servicio"), value: "servicio.text", class: "primary white--text", sortable: false},
      { text: this.$t("Cantidad sesiones inicial"), value: "cantidad", class: "primary white--text", sortable: false, align:'center'},
      { text: this.$t("Cantidad sesiones restantes"), value: "sesiones_restantes", class: "primary white--text", sortable: false, align:'center'}
    ]

    this.tabla_productos.headers = [
      { text: this.$t("Producto"), value: "producto.text", class: "primary white--text", sortable: false},
      { text: this.$t("Cantidad sesiones inicial"), value: "cantidad", class: "primary white--text", sortable: false, align:'center'},
      { text: this.$t("Cantidad sesiones restantes"), value: "sesiones_restantes", class: "primary white--text", sortable: false, align:'center'}
    ]
  },
}
</script>
